import React, { useState } from "react";
import TextBox from "../components/textBox";
import { codeWriterPrompt } from "../client/promptEngine";
import getGptResponse from "../client/getGptresponse";


function CodeWriter() {
  const [inputCode, setInputCode] = useState("");
  const [outputCode, setOutputCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [language, setLanguage] = useState(null);


  const generate = async () => {
    setIsLoading(true); 

    try {
      const prompt=codeWriterPrompt(inputCode)
      const settings={model:localStorage.getItem('model')};
      const requestBody = {settings,prompt};
      const response = await getGptResponse(requestBody)
      setOutputCode(response.response);
    } catch (error) {
        console.error('Error:', error.message);
      }
      setIsLoading(false);
  };

  return (
    <div>
      {isLoading && (
        <div className="absolute top-0 left-0 w-screen h-screen bg-black bg-opacity-50 flex justify-center items-center z-10">
          <div class="w-24 h-24 border-l-2 border-white border-opacity-75 rounded-full animate-spin"></div>
        </div>
      )}
      <div className="flex justify-between items-center py-6 font-inter">
        <div className="flex items-center">
          <h2 className="font-semibold text-lg mr-6">Get code from tests</h2>
        </div>
        <button
          type="button"
          className="rounded-full bg-flamingo-pink px-5 py-2"
          onClick={generate}
        >
          Generate
        </button>
      </div>
      <div className="flex font-bitter justify-between items-center pt-1 gap-4">
        <TextBox
          text={inputCode}
          onTextChange={(code) => setInputCode(code)}
          title="Tests for writing code"
          readOnly={false}
          language={language}
          onLanguageChange={(language) => setLanguage(language)}
        />
        <TextBox
          text={outputCode}
          onTextChange={() => {}}
          title="Generated Code"
          readOnly={true}
          language={language}
        />
      </div>
    </div>
  );
}

export default CodeWriter;
